// @flow
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { dismissResumeDBLoggedOut } from 'utils/resumeDatabase';
import {
  updateApplicantProfile,
  updateCurrentUserWith
} from '../redux/main/actions/currentUser';

const ResumeDatabaseResponseContainer = ({
  children
}: {
  children: ({ dismiss: Function }) => React.Node
}) => {
  const { currentUser } = useSelector(state => ({
    currentUser: state.currentUser
  }));
  const dispatch = useDispatch();

  const dismiss = () => {
    if (currentUser.id) {
      dispatch(
        updateApplicantProfile({
          isRecruitable: false
        })
      );
    } else {
      dismissResumeDBLoggedOut();
      dispatch(
        updateCurrentUserWith({
          isRecruitable: false
        })
      );
    }
  };

  return children({ dismiss });
};

export default ResumeDatabaseResponseContainer;
